import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const reactPlugin = new ReactPlugin();
const browserHistory = createBrowserHistory({ basename: '' });

let appInsights;

// Only initialize App Insights if instrumentation key is provided
if (process.env.REACT_APP_APPINSIGHTS_KEY) {
  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: process.env.REACT_APP_APPINSIGHTS_KEY,
      extensions: [reactPlugin],
      extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory }
      }
    }
  });
  appInsights.loadAppInsights();
} else {
  // Provide no-op stub when App Insights is not configured
  appInsights = {
    trackPageView: () => {},
    trackEvent: () => {},
    trackException: () => {},
    trackTrace: () => {},
    trackMetric: () => {},
  };
}

export { appInsights };

